import React, { useEffect, useState } from 'react';
import './SuccessMessage.css';

const SuccessMessage = ({ message, duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, duration);
    return () => clearTimeout(timer);
  }, [duration]);

  useEffect(() => {
    if (!visible) {
      const timer = setTimeout(() => {
        onClose();
      }, 500); // tempo para a transição do fade-out
      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  return (
    <div className={`success-message ${visible ? 'visible' : 'hidden'}`}>
      {message}
    </div>
  );
};

export default SuccessMessage;
